import React from 'react';

const JobDetailBenefits = props => {
  const { className, title, data = [] } = props;

  return (
    <div className={className}>
      <h2 dangerouslySetInnerHTML={{ __html: title }} />
      <ul>
        {data.map((item, i) => (
          <li key={i}>
            <h3 dangerouslySetInnerHTML={{ __html: `0${i + 1}` }} />
            <p>
              <strong>{item.theBenefitsTitle}</strong>
              {item.theBenefitsDescription}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default JobDetailBenefits;
